export default class Acc {
    constructor() {
        this.accs = [...document.querySelectorAll('.js-acc')];

        this.init();
    }

    init() {
        this.eventBind();
        this.addResize();
    }

    eventBind() {
        for (const acc of this.accs) {
            const btn = acc.querySelector('.js-acc_btn');

            this.changeHeight(acc);

            btn.addEventListener('click', () => {
                acc.classList.toggle('-open');
                this.changeHeight(acc);
            });
        }
    }

    addResize() {
        let timer;
        let prevWidth = window.innerWidth;

        window.addEventListener('resize', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (prevWidth == window.innerWidth) return;
                prevWidth = window.innerWidth;

                for (const acc of this.accs) {
                    acc.classList.remove('-open');
                    this.changeHeight(acc);
                }
            }, 300);
        });
    }

    changeHeight(acc) {
        const cont = acc.querySelector('.js-acc_cont');

        cont.style.height = acc.classList.contains('-open') ? `${cont.scrollHeight}px` : '0px';

        setTimeout(() => window.section.refresh(), 1000);
    }
}
